import React from "react";
import {
    wptable,
    price,
    planName,
} from './wptable.module.scss'

import{
    tablePad,
    doFlex,
    ltmdFlexwrap,
    tablelist,
    justifyCenter,
} from './main.module.scss' 

const plans = [
    {
        name: "Essential", text: "Basic server management", price: "$15", link: "https://bigboxhost.com/portal/cart.php?a=add&pid=289",
        features: [
            "Server Monitoring",
            "Health Checks",
            "OS Updates",
            "Server Patching",
            "Backup configuration",
            "Network Configuration",
            "Firewall Setup",
            "Basic Setup & Optimization",
        ]
    },
    {
        name: "Reactive", text: "Continuous server support", price: "$35", link: "https://bigboxhost.com/portal/cart.php?a=add&pid=290",
        features: [
            "Server Monitoring",
            "Health Checks",
            "OS Updates",
            "Server Patching",
            "Backup configuration",
            "Network Configuration",
            "Firewall Setup",
            "Basic Setup & Optimization",
            "24/7 Monitoring",
            "Proactive issue detection",
            "Advanced sec. measures",
            "Intrusion Detection",
            "Performance optimization",
            "Software installation",
            "Software configuration",
            "Data Backup Management",
            "Recovery Assistance"
        ]
    },
    {
        name: "Proactive", text: "Advanced server management", price: "$60", link: "https://bigboxhost.com/portal/cart.php?a=add&pid=292",
        features: [
            "Server Monitoring",
            "Health Checks",
            "OS Updates",
            "Server Patching",
            "Backup configuration",
            "Network Configuration",
            "Firewall Setup",
            "Basic Setup & Optimization",
            "24/7 Monitoring",
            "Proactive issue detection",
            "Advanced sec. measures",
            "Intrusion Detection",
            "Performance optimization",
            "Software installation",
            "Software configuration",
            "Data Backup Management",
            "Recovery Assistance",
            "Performance monitering",
            "Perfomance tuning",
            "Database Management",
            "Virtualization management",
            "Proactive threat detection",
            "Threat Mitigation",
            "Network DDoS Protection",
            "Advanced troubleshooting",
            "Custom Application Install",
            "MultiBackup Configuration",
            "Advanced Kernel Patching",
            "High availability setup",
            "Automated failover",
            "Specialized Escalation",
            "Priority Issue Resolution",
        ]
    },
];

const ManagedTable = () => {
    return (
        <div className={`${doFlex} ${justifyCenter} ${ltmdFlexwrap}`}>
            {plans.map((plan, index) => (
            <div className={wptable} key={index}>
                <div className={price}>{plan.price}<span>/mo.</span></div>
                <div className={planName}>{plan.name}</div>
                <p>{plan.text}</p>
                <div className={`${tablePad} ${tablelist}`}>
                    <ul>
                        {plan.features &&
                            plan.features.map((feature, index) => (
                                <li key={index}>{feature}</li>
                            ))}
                    </ul>
                </div>
                <a href={plan.link}>
                    <button>Buy Now</button>
                </a>
            </div>
            ))}
        </div>
    )
}

export default ManagedTable;